import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'

const EmptyAppointmentResults = () => (
	<VStack className="items-center flex-1 justify-center">
		<VStack className="gap-16 lg:max-w-fit max-w-72 items-center">
			<VStack gap={24} className="items-center">
				<Header className="text-center lg:max-w-fit max-w-56">Waiting on results.</Header>
				<Text className="max-w-[22rem] text-center">
					We don't have any results yet from your Wally appointments but we'll send you a
					text as soon as they're ready.
				</Text>
			</VStack>
		</VStack>
	</VStack>
)

export { EmptyAppointmentResults }
